import domReady from '@wordpress/dom-ready';

import './lib/carousel';

domReady(function() {
  const homeVid = document.querySelector('.js-bg-video');
  if (homeVid) {
    const vidAccount = homeVid.dataset.videoAccount;
    let vidOptions = ['ac_none', 'vc_auto'];

    let sizeOptions = [];
    let vidSrc = homeVid.dataset.videoDesktop;

    const pageWidth = window.innerWidth;
    if (pageWidth < 479) {
      sizeOptions = ['br_1600k', 'q_80', 'w_480', 'h_800', 'c_fill'];
      if (homeVid.dataset.mobileVideoLength) {
        sizeOptions.push(`eo_${homeVid.dataset.mobileVideoLength}`);
      }
      if (homeVid.dataset.videoMobile) vidSrc = homeVid.dataset.videoMobile;
    } else if (pageWidth < 768) {
      sizeOptions = ['br_2000k', 'q_80', 'w_800', 'h_800', 'c_fill'];
      console.log(homeVid.dataset);
      if (homeVid.dataset.tabletVideoLength) {
        sizeOptions.push(`eo_${homeVid.dataset.tabletVideoLength}`);
      }
      if (homeVid.dataset.videoTablet) vidSrc = homeVid.dataset.videoTablet;
    } else {
      sizeOptions = ['br_2500k', 'q_100'];
      if (homeVid.dataset.videoLength) {
        sizeOptions.push(`eo_${homeVid.dataset.videoLength}`);
      }
    }
    vidOptions = vidOptions.concat(sizeOptions);

    let vidOptionsString = '';
    vidOptions.forEach((opt) => {
      vidOptionsString += `${opt},`;
    });
    vidOptionsString = vidOptionsString.slice(0, -1);

    // add poster image

    homeVid.innerHTML = `<source type=\'video/mp4\' src="https://res.cloudinary.com/${vidAccount}/video/upload/${vidOptionsString}/${vidSrc}.mp4"><source type=\'video/webm\' src="https://res.cloudinary.com/${vidAccount}/video/upload/${vidOptionsString}/${vidSrc}.webm">`;

    // Handle page visibility change
    // console.log('adding visibility event');
    // document.addEventListener(visibilityChange, handleVisibilityChange, false);
  }

  newFlickity(
    '.carousel-list--home',
    {
      contain: true,
      freeScroll: false,
      pageDots: true,
      resize: true,
      reloadCells: true,
      wrapAround: true,
      imagesLoaded: true,
      autoPlay: 7000,
    },
    (el) => {
      el.on('staticClick', function(event, pointer, cellElement, cellIndex) {
        if (cellIndex != undefined) el.selectCell(cellIndex);
      });
    },
    true
  );
});

// // Set the name of the hidden property and the change event for visibility
// let hidden;
// let visibilityChange;
// if (typeof document.hidden !== 'undefined') {
//   // Opera 12.10 and Firefox 18 and later support
//   hidden = 'hidden';
//   visibilityChange = 'visibilitychange';
// } else if (typeof document.msHidden !== 'undefined') {
//   hidden = 'msHidden';
//   visibilityChange = 'msvisibilitychange';
// } else if (typeof document.webkitHidden !== 'undefined') {
//   hidden = 'webkitHidden';
//   visibilityChange = 'webkitvisibilitychange';
// }

// /**
//  * pause or play the background video depending on page visibility
//  */
// function handleVisibilityChange() {
//   console.log('handle visibility');
//   const video = document.querySelector('.js-bg-video');

//   if (video) {
//     if (document[hidden]) {
//       console.log('pause');
//       video.pause();
//     } else {
//       console.log('play');
//       video.play();
//     }
//   }
// }
